export default function Input({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  required = false,
  style = {},
  id,
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {label && (
        <label style={{ color: "#94a3b8", fontSize: 13 }}>
          {label}
          {required && <span style={{ color: "#ef4444" }}> *</span>}
        </label>
      )}
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          background: "#0f172a",
          border: "1px solid #334155",
          borderRadius: 10,
          padding: "10px 13px",
          color: "#f1f5f9",
          fontSize: 14,
          fontFamily: "inherit",
          outline: "none",
          width: "100%",
          boxSizing: "border-box",
          ...style,
        }}
      />
    </div>
  );
}
